import { render, staticRenderFns } from "./LoadingDynamic.vue?vue&type=template&id=50de1bda&scoped=true"
import script from "./LoadingDynamic.vue?vue&type=script&lang=js"
export * from "./LoadingDynamic.vue?vue&type=script&lang=js"
import style0 from "./LoadingDynamic.vue?vue&type=style&index=0&id=50de1bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de1bda",
  null
  
)

export default component.exports